import React from "react";
import SearchableDropdown from "../ui/SearchableDropdown";

// SearchableDropdown is fully controlled: typing reports the raw text with no
// option attached. This holds that search text locally and only reports upward
// once a real option is chosen, so a half-typed query never becomes the value.
// Abandoning the field (blur) restores the current selection's label.
//
// `clearOnFocus` matters here: the input's text doubles as the filter query, so
// leaving the current job's name in it on focus would filter the list down to
// that one job. Clearing on focus opens the field on the full set of options.
const JobSelect = ({ id, label, options, disabled = false, onSelect }) => {
  const [text, setText] = React.useState(label);

  React.useEffect(() => {
    setText(label);
  }, [label]);

  // Option labels carry a status suffix ("Auditor — not eligible") so the list
  // can be scanned, but the field itself should read as the job's name alone.
  const handleChange = (nextText, option) => {
    setText(option ? option.jobName || nextText : nextText);
    if (option) onSelect(option);
  };

  return (
    <div className="wif-job-select" onBlur={() => setText(label)}>
      <SearchableDropdown
        id={id}
        className="input"
        value={text}
        options={options}
        placeholder={label || "Select a job..."}
        disabled={disabled}
        clearOnFocus
        onChange={handleChange}
      />
    </div>
  );
};

export default JobSelect;
